import { Editor } from "@tinymce/tinymce-react";
import { useDispatch, useSelector } from "react-redux";
import { handleEditorContent } from "../createpaper/redux/editorSlice";

const API_KEY = "roba24w47yu1i0gzyc79o032gi6dqlmtjvp3bwbke2xe14zk";

function TinyEditor() {
  const dispatch = useDispatch();
  const { content } = useSelector((store) => store.createPaperEditor);

  const handleEditorChange = (e) => {
    dispatch(handleEditorContent(e));
  };

  return (
    <div className="px-2 w-100">
      <Editor
        onInit={(evt, editor) => {
          // editor.getBody().setAttribute("contenteditable", true);
        }}
        apiKey={API_KEY}
        value={content}
        onEditorChange={handleEditorChange}
        init={{
          height: 560,
          menubar: false,

          plugins: [
            "advlist autolink lists link image charmap preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table help wordcount print",
            "emoticons hr pagebreak directionality",
            "nonbreaking save template",
          ],
          toolbar: `undo redo | styles | fontselect fontsizeselect | 
            bold italic underline strikethrough | forecolor backcolor | 
            alignleft aligncenter alignright alignjustify | 
            bullist numlist outdent indent | 
            preview | print | pagebreak`,
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      />
    </div>
  );
}

export default TinyEditor;

/* 

Developer Settings

   plugins: [
      "advlist autolink lists link image charmap preview anchor",
      "searchreplace visualblocks code fullscreen",
      "insertdatetime media table help wordcount print",
      "emoticons hr pagebreak directionality",
      "nonbreaking save template"
    ],
    toolbar: `undo redo | styles | fontselect fontsizeselect | 
      bold italic underline strikethrough | forecolor backcolor | 
      alignleft aligncenter alignright alignjustify | 
      bullist numlist outdent indent | 
      link image media | 
      table emoticons charmap hr | 
      insertdatetime pagebreak code fullscreen print | help`,

*/
